import React from 'react';
import { InputLabelContainer } from '../../label/containers/input-label.container';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { InputErrorContainer } from '../../error/containers/input-error.container';



const modules = {
  toolbar: [
    [
      {
        header: [1, 2, 3, 4, 5, 6, false],
      },
    ],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ size: [] }],
    [{ font: [] }],
    [
      {
        align: ['right', 'center', 'justify'],
      },
    ],
    [
      { list: 'ordered' },
      { list: 'bullet' },
    ],
    ['link', 'image'],
    [
      {
        color: ['red', '#785412'],
      },
    ],
    [
      {
        background: ['red', '#785412'],
      },
    ],
  ],
};

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'link',
  'color',
  'image',
  'background',
  'align',
  'size',
  'font',
];

export function QuillEditorInputComponent ({
  value,
  onChange,
  readOnly,
  theme,
  isRequired,
  label,
  noMargin,
  onClick,
  error,
  type = 'rte',
}: any) {
    
   
  return (
    <div
    className={` mb-2 input-wrapper-overrider`}
    onClick={(event) => onClick && onClick(event)}
    style={{ marginBottom: noMargin ? 0 : undefined }}
>
  <InputLabelContainer
      isRequired={isRequired}
      label={label}
  />
    <ReactQuill
      formats={formats}
      modules={modules}
      onChange={onChange}
      readOnly={readOnly}
      theme={theme}
      value={value}
    />
     <InputErrorContainer error={error} />

</div>
  );
};

